import React from 'react';

const Footer = () => {
  return (
    <footer className="main-footer ac-footer">
      <div className="ac-footer__content">
        Action-cards® is powered by Copenhagen Risk & Safety Group ApS
      </div>
    </footer>
  );
};

export default Footer;
